import React, { useState, useContext, useMemo, useEffect, useRef } from "react";

import Style from "../InkData.module.css";
import style from "../style.module.css";
import {
  ConfigContext,
  socket,
  InkItemDataContext,
} from "../../../WebSocket/WebSocket";
import { inkDataItemInterface } from "../../../types/INK";
import DataModal from "./ModalData";
import { clickDataInterface } from "./ModalData";
import { electionInterface } from "../InkData";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import Checkbox from '@mui/material/Checkbox';

import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// @ts-ignore
import { AutoSizer, List } from "react-virtualized";

import DataBox from "./DataBox";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { dataGridLayoutTemplate, dataGridLayoutSimulationTemplate } from "./DataBox";

import { useTypeVariableStore } from "../../../WebSocket/data";


import { useTranslation } from 'react-i18next';


export interface CommandData {
  messageID: number,
  messageType: string,
  data: [{
    web_id: number,
    buffer_id: number,
    value: number,
    quality: number
  }]
}

export default function Data({
  election,
  checked,
}: {
  election: electionInterface;
  checked: boolean[] | undefined[];
}) {
  const [clickDataModal, setClickDataModal] = useState<clickDataInterface>({
    open: false,
    index: 0,
    deviceIndex: 0,
    checked: false
  });

  const [elementMenu, setElementMenu] = useState(null);
  const [checkedAll, setCheckedAll] = useState(false)
  const ws = useContext(InkItemDataContext);
  const { i18n, t } = useTranslation();
  const [inkSytemDataMaping] = useTypeVariableStore((state) => [state.device[election.deviceIndex]?.inkSytemDataMaping]);


  const inkDataItem = ws[election.deviceIndex];
  console.log("inkDataItem: ", inkDataItem)
  console.log("data table ---");
  const filteredinkDataItem = inkDataItem && inkDataItem.filter((v) => v != null).filter(data => checked[data.inkConfig.web_id] || checked[data.inkConfig.web_id] === undefined);
  if (!inkDataItem) {
    return null;
  }

  const handleClick = (event: any) => {
    setElementMenu(event.currentTarget);
  };

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const sendCommands = async (filteredinkDataItem: inkDataItemInterface[], quality:number) => {
    for (let item of filteredinkDataItem) {
      let data: CommandData = {
        messageID: 5,
        messageType: "rewrite",
        data:
          [{
            web_id: item.inkConfig.web_id,
            buffer_id: item.inkConfig.buffer_id,
            quality: quality,
            value: 0
          }]
      }
      socket[clickDataModal.deviceIndex].emit("command", data);
      await sleep(100);
      console.log("waiting")
    }
  }


  function renderRow(props: ListChildComponentProps) {
    const { index, style } = props;
    const data: inkDataItemInterface = filteredinkDataItem[index];

    return (
      <React.Fragment key={index}>
        {checked[data.inkConfig.web_id] || checked[data.inkConfig.web_id] === undefined ? (
          <DataBox
            style={style}
            setClickDataModal={setClickDataModal}
            election={election}
            data={data}
          />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }


  return (
    <>
      <div
        className={style.dataHader}
        style={{
          display: "grid",
          gridTemplateColumns: inkSytemDataMaping?.ink_test === 1 ? dataGridLayoutSimulationTemplate : dataGridLayoutTemplate,
          height: 33,
        }}
      >
        <div>Index</div>
        <div>{t("icon")}</div>
        <div></div>
        <div>{t("title")}</div>
        <div>{t("value")}</div>
        <div>{t("time-stamp")}</div>
        {inkSytemDataMaping?.ink_test === 1 && <div>I</div>}

        <div>
          <IconButton style={{ marginTop: -8, }} onClick={handleClick}>
            <MoreHorizIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            //className={style.Menu}
            anchorEl={elementMenu}
            keepMounted
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(elementMenu)}
            onClose={() => {
              setElementMenu(null);
            }}
          >
            {inkSytemDataMaping?.ink_test === 1 &&
              <MenuItem
                onClick={() => {
                  setElementMenu(null);
                  sendCommands(filteredinkDataItem, 1);
                }}
              >
                {t("set-bad-quality-to-all")}
              </MenuItem>
            }
            {inkSytemDataMaping?.ink_test === 1 &&

              <MenuItem
                onClick={() => {
                  setElementMenu(null);
                  console.log("filteredinkDataItem: ", filteredinkDataItem)
                  sendCommands(filteredinkDataItem, 0);
                  //for (let item of filteredinkDataItem) {
                  //  let data: CommandData = {
                  //    messageID: 5,
                  //    messageType: "rewrite",
                  //    data:
                  //      [{
                  //        id: item.inkConfig.id,
                  //        quality: 0,
                  //        value: 0
                  //      }]
                  //  }
                  //  socket[clickDataModal.deviceIndex].emit("command", data);
                  //  console.log("wait", item.inkConfig.id)

                  //}
                }}
              >
                {t("set-good-quality-to-all")}
              </MenuItem>
            }
          </Menu>
        </div>
        {/* <div>
        <Checkbox checked={checkedAll} style={{ marginTop: "-8px"}}
        onClick={event=>{
          setCheckedAll(checkedAll => {return !checkedAll})}
        }
         />
        </div>         */}

      </div>
      <div className={style.data}>
        {/* @ts-ignore */}
        <AutoSizer>
          {({ height, width }: any) =>
            filteredinkDataItem && (
              <FixedSizeList
                height={height - 31}
                // width={Math.max(width,1000)}
                width={width}
                // a={console.log({width})}
                itemSize={36}
                itemCount={filteredinkDataItem.length}
                overscanCount={8}
              >
                {renderRow}
              </FixedSizeList>
            )
          }
        </AutoSizer>
      </div>
      {clickDataModal.open ? (
        <DataModal dataModal={clickDataModal} setModal={setClickDataModal} />
      ) : (
        ""
      )}
    </>
  );
}
